/* eslint-disable no-underscore-dangle */
import React from "react";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import eventBus from "../helpers/events";
import contentTargeting from "../helpers/contentTargetingEvents";
import { isFirstVisit } from "asos-site-chrome-store-presentation";
import HtmlHeader from "../template/components/HtmlHeader";
import FooterComponent from "../template/components/Footer";
import WelcomeWrapperComponent from "../template/components/WelcomeWrapper";
import {
  LARGE_VIEWPORT,
  MEDIUM_VIEWPORT,
  openCookieMessage
} from "../template/state/modules/layout";

import configureStore from "../template/state";
import {
  siteChromeInitialStore,
  siteChromeTokenValues,
  asosGlobalNamespace,
  siteChromeGlobalNamespace,
  sdkGlobalNamespace,
  manifestWindowKey
} from "../template/constants";
import "../template/styles/fonts.css";
import "../template/styles/global.css";
import "../template/components/Breadcrumbs/index.css";
import loadTokenBlock from "../helpers/loadTokenBlock";
import context from "./context";
import { reloadNavigation } from "./navigation";
import { initialise as initialiseSdk } from "./sdk";
import clientConfig from "../template/clientConfig";
import loadUserProfile from "./loadUserProfile";
import addFeaturesToStore from "./addFeaturesToStore";
import siteChromeAnalytics from "./analytics/index";

/* <TODO>: remove once "asos-web-version-manifests" is updated to use window.asos._versionManifest (or otherwise) */
window[asosGlobalNamespace] = {
  ...window[asosGlobalNamespace],
  [manifestWindowKey]: window.__versionManifest
};
/* </TODO> */

const store = configureStore(
  window[asosGlobalNamespace][siteChromeGlobalNamespace][siteChromeInitialStore]
);
const firstVisit = isFirstVisit();
const { context: webContext, updateRegionalStore } = context(store);

window[asosGlobalNamespace] = {
  ...window[asosGlobalNamespace],
  webContext,
  contentTargeting,
  eventBus,
  [sdkGlobalNamespace]: {}
};

window.__sdk =
  window[asosGlobalNamespace][sdkGlobalNamespace]; /* backwards compatibility */
window.analyticsEventEmitter =
  window[asosGlobalNamespace].eventBus; /* backwards compatibility */
window.__siteChrome = {
  context: window[asosGlobalNamespace].webContext
}; /* backwards compatibility */

siteChromeAnalytics();

const updateFeatures = addFeaturesToStore(store, eventBus);

eventBus.addListener("features-sdk-ready", () =>
  updateFeatures("features-sdk-ready")
);
eventBus.addListener("features-mvt-ready", () =>
  updateFeatures("features-mvt-ready")
);

initialiseSdk(store, webContext);

const { NAVIGATION_API_PATH } = clientConfig.get();
export const updateStateWithClientData = () => {
  updateRegionalStore(() => {
    if (!NAVIGATION_API_PATH.includes("/preview/")) {
      reloadNavigation(store);
    }
  });
  loadUserProfile(store);

  const siteChromeNamespace =
    window[asosGlobalNamespace][siteChromeGlobalNamespace];
  loadTokenBlock({
    store,
    initialState: siteChromeNamespace[siteChromeInitialStore],
    newState: siteChromeNamespace[siteChromeTokenValues]
  });

  delete siteChromeNamespace[siteChromeInitialStore];

  if (firstVisit) {
    store.dispatch(openCookieMessage());
  }

  persistStore(store, {
    keyPrefix: "chrome:",
    whitelist: ["search"]
  });
};

export const Header = () => (
  <Provider store={store}>
    <HtmlHeader />
  </Provider>
);

export const Footer = () => (
  <Provider store={store}>
    <FooterComponent viewable={[LARGE_VIEWPORT, MEDIUM_VIEWPORT]} />
  </Provider>
);

export const WelcomeWrapper =
  /* istanbul ignore next */
  () => (
    <Provider store={store}>
      <WelcomeWrapperComponent />
    </Provider>
  );
